import { useMutation } from '@tanstack/react-query'
import { orpcClient as client } from './client'
import {
  authResetForgetPasswordMutation,
  authSendForgetPasswordCodeMutation,
  authSignInWithGoogleTokenMutation,
} from './generated/@tanstack/react-query.gen'

export function useSendForgetPasswordCode() {
  return useMutation({
    ...authSendForgetPasswordCodeMutation({ client }),
  })
}

export function useResetForgetPassword() {
  return useMutation({
    ...authResetForgetPasswordMutation({ client }),
  })
}

export function useSignInWithGoogleToken() {
  return useMutation({
    ...authSignInWithGoogleTokenMutation({ client }),
  })
}
